import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { List } from 'immutable';
import { PaymentTransaction } from '../../../document-data/sub-models/payment-transaction.model';
import { IMasterListHeader } from '../../../entity-master/components/master-list/master-list.interface';
import { INoItemsOptions } from '../../../feed/feed.interface';
import {
  ITrackingObject,
  TrackingScreenNamesEnum,
} from '../../../tracking/tracking.data';
import { ITransactionAction } from '../transaction-history/transaction-history.component';

@Component({
  selector: 'app-transaction-history-list',
  templateUrl: './transaction-history-list.component.html',
  styleUrls: ['./transaction-history-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TransactionHistoryListComponent implements OnInit {
  @Input() documentPaymentTransactions: List<PaymentTransaction>;
  @Input() documentLocale: string;
  @Input() isAllAccess: boolean;
  @Input() documentTrackingObject: ITrackingObject;
  @Input() trackingScreenName: TrackingScreenNamesEnum;
  @Input() headers: List<IMasterListHeader>;

  @Output()
  onAction: EventEmitter<ITransactionAction> = new EventEmitter<ITransactionAction>();

  noTransactionsOptions: INoItemsOptions;

  constructor(private _translateService: TranslateService) {}

  ngOnInit() {
    this.noTransactionsOptions = {
      description: this._translateService.instant(
        'TRANSACTION_HISTORY.NO_TRANSACTIONS'
      ),
    };
  }

  trackTransactionsByFn(index: number, paymentTransaction: PaymentTransaction) {
    return paymentTransaction.transactionId;
  }
}
